import { Alert, Box, CircularProgress } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import DefaultPlansComponent from 'src/pages/account/billing/default-plans.component';
import HttpServices from 'src/services/httpService';
import { userModuleURL } from 'src/services/urlService';

export default function GetStartedDefaultPlans() {
  const { t } = useTranslation();
  const [currentPlanDetails, setCurrentPlanDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let active = true;
    HttpServices.Get({
      url: userModuleURL.getCurrentSubscription,
      successCallback: (data) => {
        if (!active) return;
        setCurrentPlanDetails(data);
        setError(!data);
        setLoading(false);
      },
      failureCallback: () => {
        if (!active) return;
        setError(true);
        setLoading(false);
      },
    });
    return () => { active = false; };
  }, []);

  if (loading) return <Box sx={{ py: 8, textAlign: 'center' }}><CircularProgress /></Box>;
  if (error) return <Alert severity="error">{t('plan_access.load_error')}</Alert>;
  return <DefaultPlansComponent currentPlanDetails={currentPlanDetails} />;
}
